import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from 'next/link'

const LoginFooter = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(10, 15, 30, 0.95)',
        py: 2,
        px: 6,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Box sx={{ flex: 1 }} />
      <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.8rem' }}>
        © 2026 cXpify. All rights reserved
      </Typography>
      <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 3 }}>
        <Typography
          component={Link}
          href='https://www.cxpify.com/privacy-policy/'
          target='_blank'
          rel='noopener noreferrer'
          sx={{
            color: 'rgba(255,255,255,0.65)',
            fontSize: '0.8rem',
            textDecoration: 'none',
            '&:hover': { color: '#fff', textDecoration: 'underline' }
          }}
        >
          Privacy Policy
        </Typography>
        <Typography
          component={Link}
          href='https://www.cxpify.com/terms-of-use'
          target='_blank'
          rel='noopener noreferrer'
          sx={{
            color: 'rgba(255,255,255,0.65)',
            fontSize: '0.8rem',
            textDecoration: 'none',
            '&:hover': { color: '#fff', textDecoration: 'underline' }
          }}
        >
          Terms of Use
        </Typography>
      </Box>
    </Box>
  )
}

export default LoginFooter
